module.exports = __webpack_public_path__ + "static/media/CommanderShepard.9bf0f731.png";